import { ProductDivisionDetailPage } from '@/features/product-division/pages/ProductDivisionDetailPage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/product-division/$id/detail')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["product_division.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: ProductDivisionDetailPage,
})
